import React, { useEffect, useState, useCallback } from "react";
import { Tag, RefreshCw } from "lucide-react";
import api from "../lib/api";

export default function DealsNudge({ activeId, hasPlan, shops = [] }) {
  const [deals, setDeals] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (refresh = false) => {
    if (!activeId || !hasPlan) return;
    setLoading(true);
    try { const { data } = await api.get(`/deals/${activeId}`, { params: refresh ? { refresh: true } : {} }); setDeals(data); }
    catch { /* nudge is optional */ }
    finally { setLoading(false); }
  }, [activeId, hasPlan]);

  useEffect(() => { load(); }, [load]);

  if (!hasPlan) return null;
  const friendly = deals?.meals?.filter((m) => m.specials_friendly) || [];
  const shop = shops[0] || "Woolies";

  return (
    <div className="bg-[#DDEBE1] rounded-3xl border-2 border-white/60 p-4 shadow-soft" data-testid="deals-nudge">
      <div className="flex items-center gap-2">
        <span className="w-9 h-9 rounded-2xl bg-white/70 flex items-center justify-center text-emerald-700"><Tag size={18} strokeWidth={2.5} /></span>
        <div className="flex-1 min-w-0">
          <p className="font-heading font-semibold text-sorted-ink leading-tight">Specials at {shop}</p>
          <p className="text-[11px] font-semibold text-sorted-slate">
            {deals?.source === "live" ? "Matched to this week's live specials" : "Millie's estimate — no live prices"}
          </p>
        </div>
        <button onClick={() => load(true)} disabled={loading} aria-label="Refresh deals" data-testid="deals-refresh" className="w-9 h-9 rounded-full bg-white/70 flex items-center justify-center text-sorted-ink">
          <RefreshCw size={15} strokeWidth={2.5} className={loading ? "animate-spin" : ""} />
        </button>
      </div>
      {!deals && loading ? (
        <div className="h-10 rounded-2xl bg-white/50 animate-pulse mt-3" />
      ) : deals ? (
        <>
          <p className="text-sm text-sorted-ink mt-3" data-testid="deals-summary">{deals.summary}</p>
          {friendly.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2">
              {friendly.map((m) => (
                <span key={m.day} className="bg-white/80 text-sorted-ink text-[11px] font-bold px-2.5 py-1 rounded-full" title={m.note} data-testid={`deals-day-${m.day}`}>
                  {m.day.slice(0, 3)} · {m.items?.slice(0, 2).join(", ")}
                </span>
              ))}
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}
